import script from "./AdminSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSettings.vue?vue&type=script&setup=true&lang=js"

import "./AdminSettings.vue?vue&type=style&index=0&id=12916f18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12916f18"]])

export default __exports__